import { FormType } from '@office-start/forms-types';
import { getCreateFormsLink } from './getCreateFormsLink';
export function createForm(formsOptions, formType, newFileName, overrideLocationSelection, area) {
    var saveLocation = overrideLocationSelection
        ? overrideLocationSelection
        : { type: FormType.Users };
    return getCreateFormsLink(formsOptions, formType, newFileName, saveLocation.identifier, area);
}
//# sourceMappingURL=createForm.js.map